import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';

@Injectable({
  providedIn: 'root',
})
export class OportunitiesService {
  private urlProd: string = environment.apiRoot;
  constructor(private http: HttpClient) {}

  private _refresrequired = new Subject<void>();

  get Refreshrequired() {
    return this._refresrequired;
  }

  getListOportunities(page: number, limit: number) {
    return this.http.get(
      `${this.urlProd}opportunities/list-opportunity?page=${page}&limit=${limit}`,
      { context: checkToken() }
    );
  }

  madeOportunitie(body: any) {
    return this.http
      .post(`${this.urlProd}opportunities/add-opportunity`, body, {
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  updateOportunitie(id: string, body: any) {
    return this.http
      .put(
        `${this.urlProd}opportunities/update-opportunity?id_opportunity=${id}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  deleteOportunitie(id: string) {
    return this.http
      .delete(
        `${this.urlProd}opportunities/delete-opportunity?id_opportunity=${id}`,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  sendPicture(id: string, type: string, file: any) {
    const formData = new FormData();
    const esto = formData.append('image', file, file.name);
    return this.http
      .post(
        `${this.urlProd}opportunities/picture?id_opportunity=${id}&type=${type}`,
        formData,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  sendPdf(id: string, file: any) {
    const formData = new FormData();
    formData.append('pdf', file, file.name);
    return this.http.post(`${this.urlProd}/opportunities/pdf`, file, {
      context: checkToken(),
    });
  }

  sendMp4(id: string, file: any) {
    return this.http.post(`${this.urlProd}/opportunities/mp4`, file, {
      context: checkToken(),
    });
  }
}
